import { Check } from 'lucide-react'

const HeroSection = () => {
  return (
    <section className="mx-auto flex max-w-[1280px] flex-wrap items-start justify-between gap-5 px-10 py-10">
      <div className="mr-4 max-w-lg flex-1">
        {/* Main Title */}
        <div className="mb-6">
          <h1 className="mb-6 font-poppins text-3xl font-bold leading-tight md:text-4xl">
            <span className="text-gray-600">
              Raih Peluang Kerja di Jepang Gaji Hingga{' '}
            </span>
            <span className="text-red-600">50 Juta per Bulan</span>
          </h1>
        </div>

        {/* Subtitle */}
        <div className="mb-6 inline-block rounded-full bg-red-600 px-4 py-2">
          <div className="text-center text-xl font-semibold text-white">
            Get Ready to Work in Japan
          </div>
        </div>

        {/* Description */}
        <div className="mb-8">
          <div className="mb-5 text-xl leading-relaxed text-gray-600">
            <span>
              Program intensif yang dirancang khusus untuk persiapan kerja di
              Jepang dan pelatihan bahasa Jepang hingga{' '}
            </span>
            <span className="font-bold">JLPT N3</span>
            <span> hanya dalam </span>
            <span className="font-bold">7,5 bulan.</span>
          </div>

          {/* Features */}
          <div className="flex flex-wrap gap-2">
            <div className="flex items-center rounded-full border border-gray-300 bg-white px-4 py-1">
              <div className="mr-2 flex h-4 w-4 items-center justify-center rounded-full bg-red-600">
                <Check className="h-2 w-2 text-white" />
              </div>
              <div className="text-lg font-medium text-gray-700">
                Beginner Friendly
              </div>
            </div>
            <div className="flex items-center rounded-full border border-gray-300 bg-white px-4 py-1">
              <div className="mr-2 flex h-4 w-4 items-center justify-center rounded-full bg-red-600">
                <Check className="h-2 w-2 text-white" />
              </div>
              <div className="text-lg font-medium text-gray-700">
                Live Sessions
              </div>
            </div>
            <div className="flex items-center rounded-full border border-gray-300 bg-white px-4 py-1">
              <div className="mr-2 flex h-4 w-4 items-center justify-center rounded-full bg-red-600">
                <Check className="h-2 w-2 text-white" />
              </div>
              <div className="text-lg font-medium text-gray-700">
                Experienced Sensei
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Video Section */}
      <div className="relative flex h-[335px] w-[571px] max-w-full items-center justify-center">
        <div className="h-full w-full overflow-hidden rounded-lg bg-black">
          <video
            className="h-full w-full object-cover"
            controls
            preload="metadata"
            poster="/img/gijinkoku/thumbnail_video.png"
          >
            <source
              src="https://academy-r2-videos.bitlabs.id/Revisi%205%20-%20Video%20Launching%20Introduction%20Japan%20Bootcamp%20%20(1).mp4"
              type="video/mp4"
            />
            <p className="p-4 text-white">
              Your browser does not support the video tag.
              <a
                href="https://academy-r2-videos.bitlabs.id/Revisi%205%20-%20Video%20Launching%20Introduction%20Japan%20Bootcamp%20%20(1).mp4"
                className="text-blue-400 underline"
              >
                Download the video instead.
              </a>
            </p>
          </video>
        </div>
      </div>
    </section>
  )
}

export default HeroSection
